<script setup>
import { computed, onMounted } from "vue";
import { useStore } from "vuex";
import moment from "moment";
import $ from "jquery";

const store = useStore();

const loading = computed(() => store.getters["historicalLogs/isLoading"]);
const filters = computed(() => store.getters["historicalLogs/getFilters"]);

const startDate = computed({
  get: () => filters.value.startDate,
  set: (value) => {
    store.dispatch("historicalLogs/setFilters", { startDate: value });
  },
});

const endDate = computed({
  get: () => filters.value.endDate,
  set: (value) => {
    store.dispatch("historicalLogs/setFilters", { endDate: value });
  },
});

function initializeDatepicker() {
  $("#datedatepickerHistoricalLogs").daterangepicker(
    {
      startDate: moment(startDate.value),
      endDate: moment(endDate.value),
      maxDate: moment(),
      locale: {
        cancelLabel: "Clear",
        applyLabel: "Apply",
        format: "DD MMM YYYY",
      },
    },
    function (start, end) {
      startDate.value = start.format("YYYY-MM-DD");
      endDate.value = end.format("YYYY-MM-DD");
    }
  );
}

onMounted(async () => {
  initializeDatepicker();
});

const fetchHistoricalLogs = () => {
  store.dispatch("historicalLogs/fetchHistoricalLogs");
};
</script>

<template>
  <div class="pt-3 pb-4 pl-2">
    <div class="row">
      <div class="col-12 col-md-4">
        <input
          type="text"
          placeholder="Date"
          id="datedatepickerHistoricalLogs"
          class="form-control"
        />
      </div>
      <div class="col-12 col-md-2 mt-2 mt-md-0">
        <button
          @click="fetchHistoricalLogs()"
          class="btn btn-primary fetch-historical-logs"
          :disabled="loading"
        >
          <font-awesome-icon v-show="loading" :icon="['fas', 'spinner']" spin />
          <span v-show="!loading">Fetch Historical Logs</span>
        </button>
      </div>
    </div>
  </div>
</template>

<style>
.fetch-historical-logs {
  width: 180px;
}
</style>
